import React, { useState } from 'react';
import {
    Button,
    Typography,
    Card,
    FormHelperText,
    styled,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { saveAs } from 'file-saver';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import WarningIcon from '@mui/icons-material/Warning';
import TitleCase from '../BasicComponents/TitleCase';

// const useStyles = makeStyles(theme => ({
//     root: {
//         '& > *': {
//             margin: theme.spacing(1),
//         },
//     },
// }));

const TextType = styled(Typography)(() => ({
    margin: '0.5rem 0rem',
}));

export const SchoolInfoProvided = props => {
    // const classes = useStyles();
    const { getAccessTokenSilently } = useAuth0();

    const [download, setDownload] = useState(true);

    const getDownloadFile = async location => {
        return axios
            .get(location, {
                responseType: 'blob',
            })
            .then(response => response.data);
    };

    const downloadDocument = async () => {
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        let url = '/getPreBookingDocument';
        if (props.userType === 'School') {
            url = '/getSchoolPreBookingDocument';
        }

        const request = await axios.get(url, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: url,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            params: {
                Date: props.sk1,
                Filename: props.schoolUploadDocument,
                schoolid: props.schoolId,
            },
        });
        if (request.status !== 200) {
            setDownload(false);
        }

        getDownloadFile(request.data.Message.Data.downloadURL)
            .then(data => saveAs(data, props.schoolUploadDocument))
            .catch(error => {
                console.log(error);
                setDownload(false);
            });
    };

    return (
        <Card sx={{ margin: '20px 20px 40px', padding: '20px' }}>
            <Typography variant="h2" sx={{ fontSize: '2rem' }}>
                {props.title}
            </Typography>

            <Typography
                variant="h5"
                sx={{ fontSize: '1.2rem', margin: '0.5rem 0rem' }}
            >
                {props.subtitle}
            </Typography>
            <TextType variant="body1" data-cy="class-info">
                {props.text}
            </TextType>
            <TitleCase
                sx={{ margin: '0.5rem 0rem' }}
                variant="h5"
                string={`Uploaded by: ${props.uploader}`}
            ></TitleCase>

            {props.bookingDocExist && (
                <div>
                    <TextType variant="h6" data-cy="download-name">
                        File: {props.schoolUploadDocument}
                    </TextType>
                    <Button
                        onClick={() => downloadDocument()}
                        variant="outlined"
                        startIcon={<CloudUploadIcon />}
                        data-cy="download-button"
                    >
                        Download File
                    </Button>
                    {download === false && (
                        // <Typography
                        //     variant="button"
                        //     display="block"
                        //     gutterBottom
                        // >
                        //     Cannot download file
                        // </Typography>

                        <FormHelperText>
                            <WarningIcon></WarningIcon>Cannot download file
                        </FormHelperText>
                    )}
                </div>
            )}
        </Card>
    );
};

export default SchoolInfoProvided;
